import { VALID_CONVERT_TO_JPG_EXTENSION } from "../constants"
import { IFile } from "../models/IFile"
import { ConvertToJpgRequest } from "../protocol/image_processing_pb"

export function getConvertToJpgImageSavePaths(
    sourcePaths: string[],
    timestamp: number,
) {
    const suffix = `_${timestamp}`
    const outputPathCounts = sourcePaths.reduce<Record<string, number>>(
        (counts, path) => {
            if (path.endsWith("/")) {
                return counts
            }
            const extensionIndex = path.lastIndexOf(".")
            if (extensionIndex < 0) {
                return counts
            }
            const targetPath = `${path.slice(0, extensionIndex)}${suffix}.jpg`
            counts[targetPath] = (counts[targetPath] || 0) + 1
            return counts
        },
        {},
    )
    const targetPaths: string[] = []
    sourcePaths.forEach((path) => {
        if (path.slice(-1) === "/") {
            targetPaths.push(path.slice(0, -1) + suffix + "/")
            return
        }
        const extensionIndex = path.lastIndexOf(".")
        const extension =
            extensionIndex >= 0 ? path.slice(extensionIndex + 1) : ""
        if (
            extension &&
            VALID_CONVERT_TO_JPG_EXTENSION.includes(extension.toLowerCase())
        ) {
            const basePath = path.slice(0, extensionIndex)
            const defaultTargetPath = `${basePath}${suffix}.jpg`
            targetPaths.push(
                outputPathCounts[defaultTargetPath] > 1
                    ? `${path}${suffix}.jpg`
                    : defaultTargetPath,
            )
        }
    })
    return targetPaths
}

export const getValidConvertToJpgFiles = (files: IFile[]) => {
    return files.filter((file: IFile) => {
        const fileExtension = file.key?.split(".").pop()?.toLowerCase()
        return (
            file.isDir ||
            (fileExtension &&
                VALID_CONVERT_TO_JPG_EXTENSION.includes(fileExtension))
        )
    })
}

export const getConvertToJpgRequest = (
    selectedFiles: IFile[],
    timestamp: number,
    isExecutionAllowed: boolean,
) => {
    const request = new ConvertToJpgRequest()
    const sourcePaths = getValidConvertToJpgFiles(selectedFiles).map(
        (f) => f.key,
    )
    request.setKeysList(sourcePaths)
    request.setTimestamp(timestamp)
    request.setIsExecutionAllowed(isExecutionAllowed)
    return request
}
